import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './moneris-payment.html';

@Component({
  controllerAs: 'monerisPayment',
  template
})

export default class monerisPayment {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    '$stateParams',
    'spinnerService',
    'orderService',
    'authService',
    '$window', 'APP',
    'MonerisCheckout'
  ];


  constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, MonerisCheckout) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    console.log("Calling moneris-payment");
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.$toaster = $toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$window = $window;
    this.$auth = $auth;
    this.APP = APP;
    this.$spinner = $spinner;
    this.giftCardNumbers = [];
    this.totalGiftAmount = 0.00;
    this.moneris_Approval = "APPROVAL";
    this.hasPaymentInitialized = false;   
    console.log("Moneris this.$stateParams.giftcardReq : ", this.$stateParams.giftcardReq);
    this.giftCardsRequest = this.$stateParams.giftcardReq;
    this.count = 0;
    this.respMsg;

    var $ctrl = this;
    $spinner.show('appSpinner');
    if(window.innerWidth < 768) {
      console.log('mobileView');
      this.mobileView = true;
    } else {
      this.mobileView = false;
    }
    $order.getOrderAmount(this.$stateParams.orderId)
      .then(success => {
        this.orderAmount = success.data;
        this.amountToPay = this.round(this.orderAmount-this.getTotalGiftCardAddedAmount());
        if(window.innerWidth < 768) {
          console.log('inside mobile');
        }
        $order.getPaymentKeys().then(success => {
          console.log("success -- ", success);
          this.paymentGlobalKey = success.data.globalKey;
          this.monerisUrl = success.data.url;
          if(window.innerWidth < 768) {
            console.log('inside mobile');
            document.getElementById("monerisFrame").src = this.monerisUrl+"?id=" + this.paymentGlobalKey +
            "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +
            "&enable_exp_formatting=1&enable_cc_formatting=1"+
            "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
            "padding: 6px 12px;line-height: 1.42;"+
            "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px"+

            "&css_label_pan=;margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
            "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
            "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
        } else {
          // src="https://esqa.moneris.com/HPPtoken/index.php?id=htP312OIJMXU6F6&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&css_textbox_pan=width:250px;&enable_exp=1&css_textbox_exp=width:250px;&enable_cvd=1&css_textbox_cvd=width:250px;&display_labels=1&css_label_pan=color:green;" 
          document.getElementById("monerisFrame").src = this.monerisUrl+"?id=" + this.paymentGlobalKey +
            "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +
            "&enable_exp_formatting=1&enable_cc_formatting=1"+
            
            "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
            "padding: 6px 12px;line-height: 1.42;"+
            "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px"+

            "&css_label_pan=;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
            "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
            "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
        }
          this.env = success.data.enviroment;
        })
          .finally(() => $spinner.hide('appSpinner'));
      });



    $ctrl.respMsg = function (e) {
      console.log("RespMsg get called ", e );
      // var respData = eval("(" + e.data + ")");
      // var resCode = `${respData.responseCode}`;
      // var resDataKey = `${respData.dataKey}`;
      
      var parsingJson = JSON.parse(e.data);
      
      // console.log("Parsing Json : ",parsingJson);
      // console.log("dataKey : ",parsingJson.dataKey);
      console.log("responseCode : ",parsingJson.responseCode);

      var resCode = parsingJson.responseCode;
      var resDataKey = parsingJson.dataKey;
      
      if (resCode != null) {
        // resCode = resCode.split(',');
        console.log("ResCode : ", resCode, " : ResCode length: ", resCode.length);
        if (resCode.length > 0) {
          if (resCode[0] == '001') {
            $ctrl.chargeNewCardMoneris(resDataKey, $ctrl.count);
          } else {
            var srcLink = '';
            if(window.innerWidth < 768) {
              console.log('inside mobile');
               srcLink = $ctrl.monerisUrl+"?id=" + $ctrl.paymentGlobalKey +
              "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +
              "&enable_exp_formatting=1&enable_cc_formatting=1"+
              "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
              "padding: 6px 12px;line-height: 1.42;"+
              "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";

              if (resCode[0] == 943) {
                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                "&css_textbox_pan=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                "padding: 6px 12px;line-height: 1.42;"+
                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" +
                "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";

              } else if (resCode[0] == 944) {
                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_exp=margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                "&css_textbox_exp=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                "padding: 6px 12px;line-height: 1.42;"+
                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
                
              } else if (resCode[0] == 945) {
                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                "&css_textbox_cvd=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                "padding: 6px 12px;line-height: 1.42;"+
                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
              } else {
                console.log("Moneris page not loaded due to : ",resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
                $ctrl.goBack();
              }
            } else {
               srcLink = $ctrl.monerisUrl+"?id=" + $ctrl.paymentGlobalKey +
              "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +
              "&enable_exp_formatting=1&enable_cc_formatting=1"+
              "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
              "padding: 6px 12px;line-height: 1.42;"+
              "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";

              
              if (resCode[0] == 943) {
                srcLink = srcLink + "&css_label_pan=color: darkslategrey;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif"+
                "&css_textbox_pan=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                "padding: 6px 12px;line-height: 1.42;"+
                "margin-top: 5px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" +
                "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";

              } else if (resCode[0] == 944) {
                srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_exp=color: darkslategrey;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif"+
                "&css_label_cvd=margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                "&css_textbox_exp=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                "padding: 6px 12px;line-height: 1.42;"+
                "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
                
              } else if (resCode[0] == 945) {
                srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                "&css_label_cvd=color: darkslategrey;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" +
                "&css_textbox_cvd=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                "padding: 6px 12px;line-height: 1.42;"+
                "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
              } else {
                console.log("Moneris page not loaded due to : ",resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
                $ctrl.goBack();
              }
            }
            document.getElementById("monerisFrame").src = srcLink;
          }
        }
      }
    };


    if (!this.APP.ORDER.MONERIS_LOADED.loaded) {
      this.APP.ORDER.MONERIS_LOADED.loaded = true;
      console.log("Adding once this.respMsg : ", this.respMsg);
      if (window.addEventListener) {
        window.addEventListener("message", this.respMsg, false);
      }
      else {
        if (window.attachEvent) {
          window.attachEvent("onmessage", this.respMsg);
        }
      }
    }
  }

  goBack() {
    this.$toaster.pop('success', 'Payment could not process. Please reach out to store');
    this.$state.go('delivery');
  }

  round(value){
    return value.toFixed(2);
  }

  doMonerisSubmit() {
    this.$spinner.show('appSpinner');
    var monFrameRef = document.getElementById('monerisFrame').contentWindow;
    console.log("monFrameRef : ", monFrameRef);
    monFrameRef.postMessage('tokenize', this.monerisUrl);
    this.$spinner.hide('appSpinner');
    return false;
  }

  getTotalGiftCardAddedAmount() {
    var total = 0.00;
    angular.forEach(this.giftCardsRequest, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    return total;
  }

  chargeNewCardMoneris(token, callCount) {
    var $ctrl = this;

    console.log("Inide charge card Count : ", callCount);
    console.log("$ctrl.hasPaymentInitialized : ", $ctrl.hasPaymentInitialized);
    if (!$ctrl.hasPaymentInitialized) {
      $ctrl.hasPaymentInitialized = true;
      $ctrl.$spinner.show('appSpinner');
      console.log("Charging moneris card");
      let dataReq = {
        "token": token,
        "action": "charge",
        "orderId": $ctrl.$stateParams.orderId,
        // "isNewCard": true,
        // "cardLast4": resp.card.masked_card_number,
        "getGiftCardPreAuthRequest": {
          "getGiftCardPreAuthCardRequestList": $ctrl.giftCardsRequest
        }
      };
      $ctrl.$order.monerisProcess(dataReq)
        .then(success => {
          $ctrl.hasPaymentInitialized = false;
          $ctrl.$spinner.hide('appSpinner');
          $ctrl.showHeartLandPage = false;
          if (success.data.successCode === '00' && success.data.message === $ctrl.moneris_Approval) {
            $ctrl.$state.go('payment.success', {
              orderId: $ctrl.$stateParams.orderId,
              isCardSaved: true
            });
          }
          else {
            $ctrl.$state.go('payment.failure', {
              orderId: $ctrl.$stateParams.orderId,
              logString: JSON.stringify(success),
              reasonCode: success.data.successCode
            });
          }
        },
          error => {
            $ctrl.hasPaymentInitialized = false;
            $ctrl.showHeartLandPage = false;
            $ctrl.$spinner.hide('appSpinner');
            $ctrl.$state.go('payment.failure', {
              orderId: $ctrl.$stateParams.orderId,
              logString: JSON.stringify(error)
            });
          }
        )
        .catch(err => {
          $ctrl.hasPaymentInitialized = false;
          $ctrl.showHeartLandPage = false;
          console.log("Api call failure -  ", err);
          $ctrl.$spinner.hide('appSpinner');
          $ctrl.$state.go('payment.failure', {
            orderId: $ctrl.$stateParams.orderId,
            logString: JSON.stringify(err)
          });
        });
    } else {
      console.log(" Moneris Payment already iniitalized");
    }
  }
  $onDestroy = function () {
    console.log('inside destroy');
    if(this.APP.ORDER.MONERIS_LOADED.loaded){
      if (window.addEventListener) {
        this.APP.ORDER.MONERIS_LOADED.loaded = false;
        window.removeEventListener("message", this.respMsg, false);
      } else {
        if (window.attachEvent) {
          window.detachEvent("onmessage", this.respMsg);
        }
      }
    }
};
}



// WEBPACK FOOTER //
// ./src/app/order/payment/moneris-payment.js